import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Tabs, Tab, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { showDialog, showErrorDialog, showSuccessDialog } from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
// MUI
import { makeStyles, fade } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { Radio, RadioGroup, FormControlLabel } from "@material-ui/core";
import {
  addNumberSequence,
  fetchIdNumberSequence,
  selectIdSequence,
} from "../businessGroup/businessGroupSlice";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const NumberSequenceCreate = ({
  isOpen,
  handleShow,
  handleClose,
  id,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const dataId = useSelector(selectIdSequence);

  const [sequence_name, setSequence_name] = useState("");
  const [numerik_length, setNumerik_length] = useState("");
  const [start_number, setStart_number] = useState("");

  useEffect(() => {
    if (isOpen === true && id !== undefined) {
      callApi(id);
    }
  }, [id]);

  const callApi = async (id) => {
    try {
      const response = await dispatch(fetchIdNumberSequence(id));
      if (response.payload.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  // useEffect(() => {
  //   if (dataId !== null) {
  //     setSelectedValue(dataId.reset_setting);
  //     setSequence_name(dataId.sequence_name);
  //     setNumerik_length(dataId.num_size);
  //     setStart_number(dataId.initial_num);
  //   }
  // });

  const handleSave = async () => {
    const params = {
      sequence_name: sequence_name,
      initial_num: start_number,
      num_size: numerik_length,
      reset_setting: selectedValue,
    };

    console.log(params, "params");

    try {
      const response = await dispatch(addNumberSequence(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      }  else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const [selectedValue, setSelectedValue] = useState("");

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const title = id === undefined ? "New" : "Edit";

  return (
    <Modal
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={isOpen}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter text-white">
          {title} Number Sequence
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs={12} sm={3} md={6} lg={6}>
            <RedditTextField
              label="Sequence Name *"
              className={classes.margin}
              //
              variant="filled"
              id="reddit-input"
              size="small"
              fullWidth
              onChange={(e) => {
                setSequence_name(e.target.value);
              }}
              value={sequence_name}
            />
            <RedditTextField
              label="Numerik Length"
              className={classes.margin}
              variant="filled"
              id="reddit-input"
              size="small"
              type="number"
              fullWidth
              onChange={(e) => {
                setNumerik_length(e.target.value);
              }}
              value={numerik_length}
            />
          </Col>
          <Col xs={12} sm={3} md={6} lg={6}>
            {" "}
            <RedditTextField
              label="Start Number *"
              className={classes.margin}
              variant="filled"
              id="reddit-input"
              size="small"
              type="number"
              fullWidth
              onChange={(e) => {
                setStart_number(e.target.value);
              }}
              value={start_number}
            />
            <p>Reset Setting</p>
            <RadioGroup row value={selectedValue} onChange={handleChange}>
              <FormControlLabel
                value="Never"
                control={<Radio />}
                label="Never"
              />
              <FormControlLabel
                value="Daily"
                control={<Radio />}
                label="Daily"
              />
              <FormControlLabel
                value="Monthly"
                control={<Radio />}
                label="Monthly"
              />
              <FormControlLabel
                value="Annually"
                control={<Radio />}
                label="Annually"
              />{" "}
              <FormControlLabel
                value="Financial Year"
                control={<Radio />}
                label="Financial Year"
              />
            </RadioGroup>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
